<template>
  <v-dialog v-model="dialog" width="900" scrollable>
    <v-card>
      <v-toolbar color="secondary" dark flat>
        <v-toolbar-title>Detail Institusi</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0">
        <div>
          <daftar :contents="contents" :masters="masters" :detail="detail" is-view is-ajuan jenis="lpd" />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Daftar from '@views/instansi/profil/base/Daftar.vue';

export default {
  components: { Daftar },
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      detail: {},
      dialog: false,
    };
  },
  computed: {
    contents() {
      return {
        profil: {
          component: 'Profil',
          form: 'FormProfil',
          title: this.$route.meta.title,
          deskripsi: '',
          max: 10,
          optional: true,
        },
      };
    },
  },
  methods: {
    open(obj = {}) {
      this.detail = obj;
      this.dialog = true;
    },
  },
};
</script>
